import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ImageLightboxData {
  imageUrl: string;
  filename?: string;
}

@Component({
  selector: 'app-image-lightbox',
  template: `
    <div class="lightbox" (click)="$event.stopPropagation()">
      <div class="lightbox-toolbar">
        <button
          type="button"
          class="lightbox-icon-btn"
          mat-icon-button
          matTooltip="Bild herunterladen"
          (click)="downloadImage()"
          aria-label="Bild herunterladen">
          <mat-icon>download</mat-icon>
        </button>
        <button
          type="button"
          class="lightbox-icon-btn"
          mat-icon-button
          matTooltip="Schließen"
          (click)="dialogRef.close()"
          aria-label="Schließen">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="lightbox-body">
        <img [src]="data.imageUrl" alt="Bildvorschau" />
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .lightbox {
        position: relative;
        max-width: min(92vw, 1100px);
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        background: transparent;
      }
      .lightbox-toolbar {
        display: flex;
        justify-content: flex-end;
        gap: 4px;
        padding: 0 0 8px 0;
      }
      .lightbox-icon-btn {
        color: #fff;
        background: rgba(0, 0, 0, 0.45);
      }
      .lightbox-icon-btn:hover {
        background: rgba(0, 0, 0, 0.65);
      }
      .lightbox-body {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;
        max-height: calc(90vh - 48px);
      }
      .lightbox-body img {
        max-width: 100%;
        max-height: calc(90vh - 48px);
        width: auto;
        height: auto;
        object-fit: contain;
        border-radius: 4px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
        background: #111;
      }
    `,
  ],
})
export class ImageLightboxComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageLightboxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageLightboxData
  ) {}

  downloadImage(): void {
    const url = this.data.imageUrl;
    if (!url) {
      return;
    }
    const filename = this.data.filename || this.extractFilename(url) || 'image.jpg';

    fetch(url, { credentials: 'include' })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Download failed');
        }
        return response.blob();
      })
      .then((blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
      })
      .catch(() => {
        // Fallback for environments where fetch/blob download is blocked
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.target = '_blank';
        a.rel = 'noopener';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
  }

  private extractFilename(url: string): string | null {
    try {
      const parsed = new URL(url, window.location.origin);
      const f = parsed.searchParams.get('f');
      if (f) {
        return f.split('/').pop() || f;
      }
      const path = parsed.pathname.split('/').pop();
      return path || null;
    } catch {
      return null;
    }
  }
}
